import { useTranslation } from "react-i18next";
import { Modal, Button, List, ListItem, Alert } from "@deere/ux.uxframe-react";
import { PARTS_TABLE_UPLOAD_WARNING } from "../../../utils/surveyLiterals";

const ModalWarningInactiveParts = ({ showModal, setShowModal, inactiveParts, submitHandler, setExcelUploading }) => {
  const { t } = useTranslation();
  const closeModal = () => {
    setExcelUploading(false);
    setShowModal(false);
  };

  return (
    <Modal show={showModal} backdrop="static" size="lg">
      <Modal.Header>
        <Alert accessibilityLabel="warning:" variant="warning">
          <h5 className="uxf-alert-title" style={{ textAlign: "justify" }}>
            {PARTS_TABLE_UPLOAD_WARNING}
          </h5>
        </Alert>
      </Modal.Header>
      <Modal.Body className="overflow-scroll">
        <div>
          <p>
            <b>Affected Parts:</b>
          </p>
          <List>
            {inactiveParts &&
              inactiveParts.map((data) => {
                return (
                  <ListItem key={data.id}>
                    {data.supplierNumber} - {data.deerePartNumber}
                  </ListItem>
                );
              })}
          </List>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          {t("btn_cancel")}
        </Button>
        <Button type="submit" variant="primary" onClick={submitHandler}>
          {t("confirm_label")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalWarningInactiveParts;
